'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var en_US = {
    // pay
    www_title: 'DkNote',
    update_log: '',
    slogan_text1: 'DkNote is dedicated to convenient and quick recording of trivia and smart task reminders. ',
    slogan_text2: "Don't forget important and trivial things, make work and life more orderly, and start an efficient life. ",
    slogan_text3: 'Instant cloud synchronization between multiple devices.',
    slogan_h5: 'DkNote is dedicated to convenient and quick recording of trivia and smart task reminders. Important and trivial things are not forgotten, so that work and life become orderly, and an efficient life begins. Real-time cloud synchronization between multiple devices',
    android_download: 'Download',
    ios_download: 'App Store',
    support_system: 'The following platforms are supported',
    windows_button: 'Windows',
    mac_button: 'Mac',
    iphone_button: 'iPhone',
    android_button: 'Android',
    scan_download_phone: 'Scan the QR code to download mobile client',
    content_title1: 'Real-time data sync',
    content_text1: 'You can instantly synchronize notes and content between iPhone&iPad&Android phone&Android Pad. (Windows&Mac version is under development)',
    content_title2: 'Rich boutique note style',
    content_text2: 'Dozens of note styles have been carefully prepared for you, with rich and colorful record content, so that the record is no longer monotonous',
    content_title3: 'Multiple theme options',
    content_text3: 'We have carefully prepared dozens of note styles for you, change the background, change the theme, and change the mood',
    content_title4: 'Beautiful widget',
    content_text4: 'You can put your sticky notes on the desktop of your mobile phone for quick browsing, quick recording, and efficient life',
    content_title5: 'Custom Reminder',
    content_text5: 'Rich reminder settings, you can customize the time you want to be reminded at will, birthdays, parties, important things will never be forgotten',
    content_title6: 'Weekly plan, monthly plan',
    content_text6: 'Categorize and customize the plan, it is reasonable and convenient to view and record your trivial matters',
    support: 'Support',
    support_title: 'DkNote-Support',
    support_text1: 'If you have any comments and suggestions, please email us \n Email: ',
    support_text2: '',
    help: ''
};
exports["default"] = en_US;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lang/en_US.js
// module id = 270
// module chunks = 0